import { render, staticRenderFns } from "./PayBooking.vue?vue&type=template&id=5bcf447a&scoped=true&"
import script from "./PayBooking.vue?vue&type=script&lang=js&"
export * from "./PayBooking.vue?vue&type=script&lang=js&"
import style0 from "./PayBooking.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PayBooking.vue?vue&type=style&index=1&id=5bcf447a&lang=scss&scoped=true&"
import style2 from "./PayBooking.vue?vue&type=style&index=2&id=5bcf447a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf447a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCardText,VCardTitle,VCol,VIcon,VRow,VSpacer})
